import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Home } from "lucide-react";
import { useApp } from "../context/AppContext";

// items: [{ to, label }] — last item is the current page
export default function Breadcrumbs({ items }) {
  const { lang } = useApp();
  const Sep = lang === "ar" ? ChevronLeft : ChevronRight;
  return (
    <nav className="crumbs" aria-label="breadcrumb" data-testid="breadcrumbs">
      <Link to="/" className="crumb" data-testid="crumb-home">
        <Home size={13} />
        <span>{lang === "ar" ? "الرئيسية" : "Home"}</span>
      </Link>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.to || it.label} className="crumb-seg">
            <Sep size={13} className="crumb-sep" />
            {last || !it.to ? (
              <span className="crumb current" aria-current="page" data-testid="crumb-current">{it.label}</span>
            ) : (
              <Link to={it.to} className="crumb" data-testid={`crumb-${it.to.replace(/\//g, "-").slice(1)}`}>{it.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
